import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import { useAppConfigStore } from './app-config-store';
import { useWindowSize, eagerComputed } from '@vueuse/core';

export const useAppLayoutStateStore = defineStore(
    'freya-app-layout-state',
    () => {
        const appConfig = useAppConfigStore();

        const staticMenuDesktopInactive = ref<boolean>(false);
        const overlayMenuActive = ref<boolean>(false);
        const configSidebarVisible = ref<boolean>(false);
        const staticMenuMobileActive = ref<boolean>(false);
        const menuHoverActive = ref<boolean>(false);
        const rightMenuActive = ref<boolean>(false);
        const topbarMenuActive = ref<boolean>(false);
        const sidebarActive = ref<boolean>(appConfig.sidebarAnchored);
        const overlaySubmenuActive = ref<boolean>(false);

        const mobileBreakpoint = ref<number>(991);

        // MOBILE/DESKTOP
        const { width: windowWidth } = useWindowSize();

        const isMobile = eagerComputed(
            () => windowWidth.value <= mobileBreakpoint.value
        );
        const isDesktop = eagerComputed(() => !isMobile.value);

        function showConfigSidebar() {
            configSidebarVisible.value = true;
        }

        function showSidebar() {
            rightMenuActive.value = true;
        }

        function toggleMenu() {
            if (appConfig.menuMode === 'overlay') {
                overlayMenuActive.value = !overlayMenuActive.value;
            }

            if (isDesktop.value) {
                staticMenuDesktopInactive.value =
                    !staticMenuDesktopInactive.value;
            } else {
                staticMenuMobileActive.value = !staticMenuMobileActive.value;
            }
        }

        function toggleConfigSidebar() {
            configSidebarVisible.value = !configSidebarVisible.value;
        }

        const isSidebarActive = computed(
            () => overlayMenuActive.value || staticMenuMobileActive.value
        );

        const fullLogo = computed(() => {
            switch (appConfig.menuMode) {
                case 'slim':
                case 'slim-plus':
                    return false;
                case 'static':
                case 'overlay':
                case 'horizontal':
                    return true;
                case 'reveal':
                case 'drawer':
                default:
                    return sidebarActive.value;
            }
        });

        return {
            staticMenuDesktopInactive,
            overlayMenuActive,
            configSidebarVisible,
            staticMenuMobileActive,
            menuHoverActive,
            rightMenuActive,
            topbarMenuActive,
            sidebarActive,
            overlaySubmenuActive,
            showConfigSidebar,
            showSidebar,
            toggleMenu,
            isMobile,
            isDesktop,
            mobileBreakpoint,
            toggleConfigSidebar,
            isSidebarActive,
            fullLogo,
        };
    }
);
